import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { auth } from "../../utils/auth";
import { getLink } from "../../utils/helpers";
import { request } from "../../utils/request";

const MobileHeader = () => {
    const [showMenu, setshowMenu] = useState(false);

    let history = useHistory();

    function toggleMenu() {
        setshowMenu(!showMenu);
    }

    async function setSucursal(sid) {
        const res = await request("sset?sid=" + sid);

        if (res.success) {
            window.localStorage.setItem("sucursalActual", res.data.id);
            history.push("/" + res.data.id);
        }
    }

    const usuario = auth.getUser();

    return (
        <header className='header-mobile d-block d-lg-none'>
            <div className='header-mobile__bar'>
                <div className='container-fluid'>
                    <div className='header-mobile-inner'>
                        <a className='logo' href={getLink("/")}>
                            <img src='images/icon/logo.png' alt='CoolAdmin' />
                        </a>
                        <button
                            onClick={() => toggleMenu()}
                            className='hamburger hamburger--slider'
                            type='button'>
                            <span className='hamburger-box'>
                                <span className='hamburger-inner'></span>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <nav className={"navbar-mobile " + (showMenu ? "show" : "")}>
                <div className='container-fluid'>
                    <ul className='navbar-mobile__list list-unstyled'>
                        {usuario.sucursales.map((sucursal) => (
                            <li key={sucursal.id}>
                                <button
                                    className={
                                        "btn " +
                                        (parseInt(
                                            window.localStorage.getItem(
                                                "sucursalActual"
                                            )
                                        ) === sucursal.id
                                            ? "current"
                                            : "")
                                    }
                                    onClick={() => setSucursal(sucursal.id)}>
                                    {sucursal.nombre}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </nav>
        </header>
    );
};

export default MobileHeader;
